"use client";
import { PartialPartner } from "@/common/partner/types";
import Icon from "@/components/icons";
import useProgramRedesignTraffic from "@/monarch/rules/programRedesignTraffic/useProgramRedesignTraffic";
import Image from "next/image";

type SideRailTitleProps = {
  text?: string;
  iconType?: string;
  partners?: PartialPartner[];
};

export default function SideRailTitle({
  text = "Earn Certificate",
  iconType = "card-membership",
  partners,
}: SideRailTitleProps) {
  const { sideRailTitle } = useProgramRedesignTraffic();
  const { text: titleText } = sideRailTitle || {};

  const hasMultiplePartners = partners && partners.length > 1;

  const containerClassName = `flex ${hasMultiplePartners ? "flex-col md:flex-row" : ""} overflow-hidden items-center md:justify-center gap-4 md:gap-2`;
  const titleClassName = `text-primary-500 text-md md:text-xl m-0 font-bold text-center ${hasMultiplePartners ? "w-full md:w-auto" : ""}`;

  return (
    <div className={containerClassName}>
      <div className="flex gap-2">
        {partners?.length &&
          partners.map((partner) => {
            return (
              <Image
                key={partner.uuid}
                src={partner.logoUrl}
                alt="Program Logo"
                width={157}
                height={58}
                className="flex-shrink-0 md:hidden"
              />
            );
          })}
      </div>
      <div className="hidden md:block">
        <Icon type={iconType} svgProps={{ width: 32, height: 32 }} />
      </div>
      <p className={titleClassName}>{titleText ?? text}</p>
    </div>
  );
}
